import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import useScreen from "../components/common/UseScreen";

const StyledPageBannerTextContainer = styled(Box)(() => {
  const { isDesktop } = useScreen();
  return {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    display: "flex",
    flexDirection: "column",
    width: isDesktop ? "70%" : "90%",
    alignItems: "center",
    textAlign: "center",
  };
});

export default StyledPageBannerTextContainer;
